import { isMyonApiSuccess, MyonApiResponse } from "shared/Api/MyonApiResponse";
import { HttpClient } from "silver";

type SetResponse = {
	bookId: number;
	gradeId: number;
	modified: string;
};

type SetManyResponse = {
	bookIds: number[];
	gradeId: number;
	modified: string;
};

export class BookMinimumGradeAccessService{

	constructor(
		private httpClient: HttpClient
	) { }

	public async set(bookId: number, gradeId: number): Promise<SetResponse> {
		const body = { bookId, gradeId };
		const response: MyonApiResponse<SetResponse> = await this.httpClient.post("/api/minimumgradebookaccess/set", { body });

		if (! isMyonApiSuccess(response)) {
			console.error(response);
			throw new Error("Error while setting minimum grade access");
		}
		return response.result;
	}

	public async setMany(bookIds: number[], gradeId: number, buildingId?: number): Promise<SetManyResponse> {
		let action = "/api/minimumgradebookaccess/setMany";
		if (buildingId) {
			const params = new URLSearchParams();
			params.set("buildingId", String(buildingId));
			action += "?" + params.toString();
		}

		const response: MyonApiResponse<SetManyResponse> = await this.httpClient.post(action, { body: {
			grade: String(gradeId),
			books: bookIds.map(String)
		}});

		if (! isMyonApiSuccess(response)) {
			console.error(response);
			throw new Error("Error while setting minimum grade access");
		}
		return response.result;
	}

}
